<template>
    <div class="block-work-with-us-quotes-outer">
        <!--<div ref="spacer" class="block-work-with-us-quotes-spacer"></div>-->
        <div ref="workQuotesContainer" class="block-work-with-us-quotes">
            <div class="capper">
                <div class="capper-padded">
                    <div class="quote-panels" ref="panelsContainer">
                        <!-- Each panel wrapper is now 100vh tall and in normal flow -->
                        <div
                            v-for="(item, index) in json.quoteBlocks"
                            :key="`quote-panel-wrapper-${index}`"
                            class="quote-panel-wrapper"
                        >
                            <div class="quote-panel" :class="{ reverseZ: index % 2 !== 0 }">
                                <div class="quote-l">
                                    <div class="quote-l2">
                                        <div class="line-top-outer">
                                            <WorkWithUsLineTop class="line-top"/>
                                        </div>
                                        <h2>{{ item.title }}</h2>
                                        <div class="quote" v-html="parseQuote(item.quote)"></div>
                                        <div v-if="item.attribution" class="attribution">
                                            {{ item.attribution }}
                                        </div>
                                        <div class="line-bottom-outer">
                                            <WorkWithUsLineBottom class="line-bottom"/>
                                        </div>
                                    </div>
                                </div>
                                <div class="quote-r">
                                    <div class="quote-r2">
                                        <div class="bg-panel"></div>
                                        <video v-if="item?.quoteVideo?.[0]?.url" class="theimg-hook" preload="metadata" muted autoplay loop :poster="item?.quoteImage?.[0]?.url" webkit-playsinline playsinline>
                                            <source :src="item?.quoteVideo?.[0]?.url" type="video/mp4">
                                        </video>
                                        <img v-else class="theimg-hook" :alt="item?.quoteImage?.[0]?.title" :src="item?.quoteImage?.[0].url" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- end wrapper -->
                    </div>
                    <div class="mobile-scroll-buffer"></div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gh from "@/helpers/gh";
import { isMobile } from 'mobile-device-detect'
import WorkWithUsLineTop from "@/components/svgs/WorkWithUsLineTop.vue";
import WorkWithUsLineBottom from "@/components/svgs/WorkWithUsLineBottom.vue";
export default {
    name: "WorkWithUsQuotes",
    components: {WorkWithUsLineBottom, WorkWithUsLineTop },
    props: {
        json: {
            type: Object,
            required: true,
            default: null,
            fixedScreenHeight: null,
            didOnce: null,
        },
    },
    data() {
        return {
            gh,
            fixedScreenHeight: 0,
            lastResizeWidth: 0,
            ticking: false,
            isIOSSafari: false,
        };
    },
    mounted() {
        this.isIOSSafari = this.checkIOSSafari();
        this.fixedScreenHeight = window.innerHeight;
        this.lastResizeWidth = window.innerWidth;

        window.addEventListener("scroll", this.onScroll, { passive: true });
        window.addEventListener("resize", this.resize);
        this.handleScroll(); // initial call

    },
    beforeUnmount() {
        window.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("resize", this.resize);
    },
    methods: {
        checkIOSSafari() {
            const ua = window.navigator.userAgent;
            const isAppleMobile = /iP(ad|hone|od)/.test(ua) || (ua.includes('Macintosh') && window.navigator.maxTouchPoints > 1);
            if (!isAppleMobile) return false;
            if (!/Safari/.test(ua)) return false;
            if (/CriOS|FxiOS|EdgiOS|OPiOS/.test(ua)) return false;
            return true;
        },
        resize() {
            const w = window.innerWidth;
            const widthChanged = w !== this.lastResizeWidth;

            // Mobile Safari fires "resize" on scroll as the browser chrome collapses/expands.
            // Only react to width changes on mobile to keep scroll math stable.
            if (isMobile && !widthChanged) return;

            if (widthChanged) {
                this.lastResizeWidth = w;
            }

            // Keep the measurement stable on iOS Safari; otherwise update normally.
            if (!this.isIOSSafari || widthChanged) {
                this.fixedScreenHeight = window.innerHeight;
            }

            this.onScroll();
        },
        onScroll() {
            if (this.ticking) return;

            this.ticking = true;
            window.requestAnimationFrame(() => {
                this.handleScroll();
                this.ticking = false;
            });
        },
        parseQuote(quote) {
            return `“${gh.removeTags(quote) }”`
        },
        handleScroll() {
            const panelsContainer = this.$refs.panelsContainer;
            if (!panelsContainer) return;

            const panels = panelsContainer.querySelectorAll(".quote-panel-wrapper");

            const container = this.$refs.workQuotesContainer;
            const label = document.querySelector('.working-with-us-label');
            if (container && label) {
                const containerRect = container.getBoundingClientRect();
                label.style.opacity = (containerRect.top < 0 && containerRect.bottom > 200) ? 1 : 0;
            }

            const smallWidth = window.innerWidth < 850;

            panels.forEach(panelWrapper => {
                const rect = panelWrapper.getBoundingClientRect();
                const panel = panelWrapper.querySelector(".quote-panel");
                if (!panel) return;

                const bgPanel = panel.querySelector(".bg-panel");
                const quoteL2 = panel.querySelector(".quote-l2");
                const imgHook = panel.querySelector(".theimg-hook");

                const viewportHeight = this.fixedScreenHeight || window.innerHeight;
                const panelMid = rect.top + rect.height / 2;
                const viewportMid = viewportHeight / 2;
                let position = (panelMid - viewportMid) / viewportMid;
                position = Math.max(-1, Math.min(1, position)); // Clamp between -1 and 1

                // Map position to pixel shift
                let shift
                if (smallWidth) {
                    shift = 0
                } else {
                    shift = position * 50;
                }


                if (quoteL2) {
                    quoteL2.style.transform = `translate3d(0, ${shift}px, 0)`;
                }

                if (bgPanel && imgHook) {
                    if (this.isIOSSafari && !bgPanel.dataset.noScrollTransition) {
                        bgPanel.style.transition = 'none';
                        bgPanel.dataset.noScrollTransition = '1';
                    }

                    const imgRect = imgHook.getBoundingClientRect();
                    const imgHeight = imgRect.height;
                    const bgHeight = bgPanel.offsetHeight;

                    let topShift, bottomShift;

                    if (smallWidth) {
                        topShift = -(imgHeight - bgHeight + 50);
                        bottomShift = 25;
                    } else {
                        topShift = -(imgHeight - bgHeight + 125);
                        bottomShift = 50;
                    }

                    // Interpolate linearly based on position
                    const bgShift = topShift + (bottomShift - topShift) * ((position + 1) / 2);

                    bgPanel.style.transform = `translate3d(0, ${bgShift}px, 0)`;
                }
            });
        }




    }
};
</script>
